var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8335C4.50846 10.8335 2.5 12.7087 2.5 15.4217V15.8335C2.5 16.2937 2.8731 16.6668 3.33333 16.6668H11.6667C12.1269 16.6668 12.5 16.2937 12.5 15.8335V15.4217C12.5 12.7087 10.4915 10.8335 7.5 10.8335Z",
    stroke: "#5A6677",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 6.3335C4.58301 4.67664 5.88884 3.3335 7.49967 3.3335C9.1105 3.3335 10.4163 4.67664 10.4163 6.3335V7.8335C10.4163 9.49035 9.1105 10.8335 7.49967 10.8335C5.88884 10.8335 4.58301 9.49035 4.58301 7.8335V6.3335Z",
    stroke: "#5A6677",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4773 17.5H16.6671C17.5876 17.5 18.3338 16.7538 18.3338 15.8333V15.4215C18.3338 13.0579 16.8325 11.3098 14.7775 10.5002C15.4334 9.80684 15.8338 8.86314 15.8338 7.83333V6.33333C15.8338 4.23853 14.1768 2.5 12.0838 2.5C11.6944 2.5 11.3201 2.56017 10.9688 2.67162C11.4045 3.0999 11.7627 3.60701 12.0229 4.16759C12.0431 4.16698 12.0634 4.16667 12.0838 4.16667C13.2124 4.16667 14.1671 5.11443 14.1671 6.33333V7.83333C14.1671 8.89882 13.4376 9.75712 12.5001 9.95631V10.0343L13.614 11.8602C15.464 12.3539 16.6671 13.7404 16.6671 15.4215V15.8333H15.0001C15.0001 16.453 14.8069 17.0276 14.4773 17.5Z",
    fill: "#5A6677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayGroup);
export default __webpack_public_path__ + "static/media/gray-group.50cd9c41cc570f548aa065b1d320c699.svg";
export { ForwardRef as ReactComponent };